import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import HeroSimple from '../HeroSimple';
export function Rewards() {
  const $ = _c(17);
  const {
    t
  } = useTranslation("discounts");
  let t0;
  if ($[0] !== t) {
    t0 = t("rewards.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionHeadline className="mx-auto mb-5 max-w-192" anchorKey="rewards.title">{t0}</SectionHeadline>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("rewards.text");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Text className="max-w-142 text-center" variant="p2">{t2}</Text>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = LINKS();
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = t4.rewards;
  let t6;
  if ($[9] !== t) {
    t6 = t("rewards.button");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Button to={t5} testId="discountsReward" analyticsParam="discountsReward" size="lg" variant="primary" align="center" className="mt-10 md:mt-12">{t6}</Button>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t7) {
    t8 = <HeroSimple circleClassName="hidden" contentClassName="py-10 lg:py-20">{t1}{t3}{t7}</HeroSimple>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}